import { render, staticRenderFns } from "./ShipsWithOrders.vue?vue&type=template&id=db365c3a"
import script from "./ShipsWithOrders.vue?vue&type=script&lang=ts"
export * from "./ShipsWithOrders.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports